import { atom } from 'recoil';
import { resolveRealtimePath } from '@services/db/helper';
import { IShopOperator } from '../types/dbRecords';

export const RAW_MATERIALS_COLLECTION = atom({
  key: 'RAW_MATERIALS_COLLECTION',
  default: 'rawMaterials',
});
export const NON_CONFORMANCE_COLLECTION = atom({
  key: 'NON_CONFORMANCE_COLLECTION',
  default: 'non-conformance',
});
export const GL_CODES_COLLECTION = atom({
  key: 'GL_CODDES_COLLECTION',
  default: 'gl-codes',
});
export const PRODUCT_CODES_COLLECTION = atom<string>({
  key: 'PRODUCT_CODES_COLLECTION',
  default: 'product-codes',
});
export const ROUTER_DATA_PATH = atom({
  key: 'ROUTER_DATA_PATH',
  default: resolveRealtimePath('router'),
});

export const RECORD_NUMBERS_COLLECTION = atom({
  key: 'RECORD_NUMBERS_COLLECTION',
  default: resolveRealtimePath('recordNumbers'),
});

export const TERMS_DB_COLLECTION = atom({
  key: 'TERMS_DB_COLLECTION',
  default: 'terms',
});

export const CREDIT_MEMO_DB_COLLECTION = atom({
  key: 'CREDIT_MEMO_DB_COLLECTION',
  default: 'credit-memos',
});

export const shopOperatorsObjectAtom = atom <IShopOperator[]>({
  key: 'shopOperatorsAtom',
  default: [],
});

export const currentShopOperatorsListAtom = atom<IShopOperator[]>({
  key: 'currentShopOperatorsListAtom',
  default: [],
});

export const currentShopOperatorAtom = atom({
  key: 'currentShopOperatorAtom',
  default: '',
});

export interface IUserSettings {
  boolean: {
    useTestData: boolean;
    useWeightedPartsPerDay: boolean;
    showCNCLoad: boolean;
    showAshTag: boolean;
    showFinishingLoad: boolean;
    showDecimalWeights: boolean;
    showInventoryMargin: boolean;
    showSameDescription: boolean;
    showOriginalPricing: boolean;
    predictMaterialBOM: boolean;
    showHelpHighlights: boolean;
    useProdDataInDev: boolean;
    showDevTools: boolean;
    enableAIDescriptionValidation: boolean;
    /** Floating env-hop button (staging ↔ production). Default on for admins. */
    showEnvHopButton: boolean;
  };
  string: {
    scrollToLocation: string;
  };
}

export const USER_SETTINGS_DEFAULTS: IUserSettings = {
  boolean: {
    useTestData: false,
    useWeightedPartsPerDay: false,
    showCNCLoad: false,
    showAshTag: false,
    showFinishingLoad: false,
    showDecimalWeights: false,
    showInventoryMargin: false,
    showOriginalPricing: false,
    predictMaterialBOM: false,
    showHelpHighlights: false,
    useProdDataInDev: false,
    showDevTools: false,
    enableAIDescriptionValidation: false,
    showSameDescription: false,
    showEnvHopButton: true,
  },
  string: {
    scrollToLocation: 'current',
  },
};

export const userSettingsAtom = atom<IUserSettings | null>({
  key: 'userSettingsAtom',
  default: null,
});
